import EventTypeEvaluationPersonUpdated from './EventTypeEvaluations/PersonUpdated/PersonUpdated';
import EventTypeEvaluationBusinessUpdated from './EventTypeEvaluations/BusinessUpdated/BusinessUpdated';
import EventTypeEvaluationsExternalAccountCreated from './EventTypeEvaluations/ExternalAccountCreated/ExternalAccountCreated';
import EventTypeEvaluationTransaction from './EventTypeEvaluations/Transaction/Transaction';

export const DATA_SERVICES = {
  LexisNexisWorldCompliance: 'LexisNexis WorldCompliance',
  Socure30: 'Socure 30',
};

export const DISPLAY_STATUSES = ['webhook_pending', 'waiting'];

export const EVENT_TYPE_EVALUATION_MAPPING = {
  business_updated: EventTypeEvaluationBusinessUpdated,
  external_account_created: EventTypeEvaluationsExternalAccountCreated,
  person_updated: EventTypeEvaluationPersonUpdated,
  transaction: EventTypeEvaluationTransaction,
};
